import { render, staticRenderFns } from "./notifications-page.vue?vue&type=template&id=f8a0eb72&scoped=true&"
import script from "./notifications-page.vue?vue&type=script&lang=js&"
export * from "./notifications-page.vue?vue&type=script&lang=js&"
import style0 from "./notifications-page.vue?vue&type=style&index=0&id=f8a0eb72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a0eb72",
  null
  
)

export default component.exports